<template>
  <basic-container class="orderList">
    <avue-crud
      :option="tableOption"
      :data="tableData"
      :page.sync="page"
      @search-change="searchChange"
      ref="crud"
      @on-load="getList"
      :search.sync="searchForm"
      @row-dblclick="expandChanges"
    >
      <template slot="fieldNameSearch">
        <el-select
          v-model="searchForm.fieldCode"
          clearable
          placeholder="请选择"
        >
          <el-option
            class="p-lr-10"
            v-for="item in industryListArr"
            :key="item.fieldId"
            :label="item.fieldName"
            :value="item.fieldId"
          >
            {{ item.fieldName }}
            <span v-if="item.isHot == 1" class="p-lr-0">（爆品）</span>
          </el-option>
        </el-select>
      </template>
      <template slot="expand" slot-scope="scope">
        <el-table :data="scope.row.flowList" style="width: 100%">
          <el-table-column label="任务类型" prop="orderFlow">
            <template slot-scope="props">
              <span>
                {{
                  $flowType.get(
                    props.row.orderFlow == 4
                      ? props.row.flowLevel
                      : props.row.orderFlow,
                  )
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="当前状态" prop="status">
            <!-- -1.已终止，0未开始 1.待配置，2.待领取，3.进行中，4.已完成-->
            <template slot-scope="props">
              <span>
                {{
                  props.row.status === -2
                    ? '进行中'
                    : $flowStatus.get(props.row.status)
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="成本信息">
            <template slot-scope="props">
              <span>{{ props.row.amount }}</span>
              <span>
                {{
                  props.row.addAmount
                    ? '(含加价成本：' + props.row.addAmount + '元)'
                    : ''
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="props">
              <el-button
                v-if="
                  props.row.status !== 0 &&
                  props.row.status !== -1 &&
                  props.row.orderFlow !== 8 &&
                  props.row.orderFlow !== 9
                "
                @click="
                  handleClick(
                    props.row.orderFlow,
                    props.row.id,
                    props.row.status,
                    props.row.orderId,
                    props.row.flowLevel,
                  )
                "
                type="text"
                size="small"
              >
                {{ props.row?.status === 1 ? '去配置' : '查看' }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>

      <template slot="status" slot-scope="scope">
        <span v-if="scope.row?.status === -1">已取消</span>
        <span v-if="scope.row?.status === 1">进行中</span>
        <span v-if="scope.row?.status === 2">已提交</span>
      </template>

      <template slot="lan" slot-scope="scope">
        <span>
          {{ $sysLan.get(scope.row.slan) }}=>{{ $sysLan.get(scope.row.tlan) }}
        </span>
      </template>

      <template slot="orderId" slot-scope="scope">
        <span>
          {{ scope.row.id
          }}{{ permissions.dot_show_pm ? '[' + scope.row.pmName + ']' : '' }}
        </span>
      </template>
      <template slot="fieldName" slot-scope="scope">
        <i class="icon-huobao c-red" v-if="scope.row.isHot == 1"></i>
        {{ scope.row.fieldName || '--' }}
      </template>

      <template slot="createTime" slot-scope="scope">
        <span>{{ formatDate(scope.row.createTime) }}</span>
      </template>

      <template slot="step" slot-scope="scope">
        <span
          v-for="(item, i) in scope.row?.flowList?.filter(
            (i) => i.orderFlow !== 7 && i.orderFlow !== 8 && i.orderFlow !== 9,
          )"
          :key="i"
        >
          <span
            :class="[
              'hack',
              { 'hack-h': item.status === 3 || item.status === -2 },
              { 'hack-config': item.status === 1 || item.status === -3 },
              { 'hack-hover': item.status !== 0 },
            ]"
            @click="
              handleClick(
                item.orderFlow,
                item.id,
                item.status,
                item.orderId,
                item.flowLevel,
              )
            "
          >
            {{
              $flowType.get(
                item.orderFlow == 4 ? item.flowLevel : item.orderFlow,
              )
            }}
          </span>
          {{
            i ===
            scope.row.flowList.filter(
              (i) =>
                i.orderFlow !== 7 && i.orderFlow !== 8 && i.orderFlow !== 9,
            ).length -
              1
              ? ''
              : '--'
          }}
        </span>
      </template>

      <template slot-scope="{ row, index }" slot="menu">
        <template v-if="permissions.dot_order_detail">
          <el-button
            type="success"
            icon="el-icon-document"
            size="mini"
            class="m-r-10"
            plain
            @click="toOrderDetail(row.id)"
          >
            下单信息
          </el-button>
        </template>

        <template
          v-if="
            row.status === 1 &&
            permissions.dot_order_submit &&
            canSubmit(row.flowList)
          "
        >
          <el-button
            type="primary"
            icon="el-icon-check"
            size="mini"
            plain
            @click.stop="presSubmitOrder(row, orderIndex)"
          >
            提交订单
          </el-button>
        </template>
      </template>
    </avue-crud>

    <el-dialog
      title="术语新增详情"
      :visible.sync="termAuditDialogVisible"
      center
    >
      <el-row>
        <el-select
          size="small"
          v-model="termType"
          placeholder="请选择"
          @change="selectChange"
        >
          <el-option label="新增" :value="1" />
          <el-option label="审核" :value="2" />
        </el-select>
      </el-row>
      <avue-crud
        ref="crud"
        :option="termTableOption"
        :search.sync="termSearch"
        @on-load="selectChange(termType)"
        :data="termTableData"
        :page.sync="termPage"
        v-model="termSearch"
      >
        <template slot="createTime" slot-scope="scope">
          <span>{{ formatDate(scope.row.createTime) }}</span>
        </template>
      </avue-crud>
    </el-dialog>
  </basic-container>
</template>
<script>
import { industry } from '@/api/qc/manage';
import { pageOrder, submit, termPassPage } from '@/api/dot/order';
import { statistics } from '@/api/dot/flow';
import { tableOption, termTableOption } from '@/const/crud/dot/order';
import { mapGetters, mapState } from 'vuex';
import { formatDate } from '@/util/date';
import {
  alertErroMsg,
  alertSuccessMsg,
  errorSubmitOrderMsg,
} from '@/util/commonMsg';

export default {
  data() {
    return {
      termType: 1,
      termAuditDialogVisible: false,
      termOrderId: '',
      search: {},
      termSearch: {},
      termTableData: [],
      tableData: [],
      searchForm: {
        fieldCode: '',
      },
      page: {
        pageSize: 20,
        pagerCount: 5,
      },
      termPage: {
        pageSize: 20,
        pagerCount: 5,
        currentPage: 1,
        total: 0,
      },
      tableOption: tableOption,
      termTableOption: termTableOption,
      dataChild: [],
      staParams: null,
      industryListArr: [],
    };
  },
  computed: {
    ...mapGetters(['permissions']),
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  created() {
    if (this.$route.query.sourceId) {
      this.searchForm.sourceId = this.$route.query.sourceId;
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.curPath = to.path;
      vm.oldPath = from.path;
    });
  },
  mounted() {
    this.getIndustryList();
    this.staParams = {
      u_id: this.userInfo.staffId,
      time: new Date().getTime(),
      browser: navigator.userAgent.toLowerCase(),
      url: this.curPath,
      ref_url: this.oldPath,
      scene_name: '订单列表',
    };
    this.statistics();
  },
  methods: {
    statistics() {
      statistics(
        Object.assign(
          {
            event_type: 'view',
          },
          this.staParams,
        ),
      );
    },

    // 获取领域列表
    getIndustryList() {
      industry({}).then((res) => {
        this.industryListArr = res.data?.data;
      });
    },

    toOrderDetail(id) {
      this.$router.push({ path: '/dot/order/detail/' + id });
      statistics(
        Object.assign(
          {
            event_name: '下单信息',
            event_type: 'click',
          },
          this.staParams,
        ),
      );
    },

    selectChange(val) {
      this.getTermPassPage(this.termPage, {}, this.termOrderId, val);
    },
    formatDate(time) {
      let date = new Date(parseFloat(time));
      return formatDate(date, 'yyyy-MM-dd hh:mm');
    },
    canSubmit(flowList) {
      let hasProcessing = false;
      if (flowList) {
        flowList.forEach((ele) => {
          if (
            (ele.status === 3 || ele.status === -2) &&
            ele.orderFlow !== 6 &&
            ele.orderFlow !== 7
          ) {
            hasProcessing = true;
          }
        });
      }
      return !hasProcessing;
    },
    getList(page, params) {
      this.tableLoading = true;
      pageOrder(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
            pmId: this.userInfo.staffId,
            id: this.searchForm.orderId,
          },
          params,
          this.searchForm,
        ),
      ).then((response) => {
        this.tableData = response.data.data.records;
        this.page.total = response.data.data.total;
        this.tableLoading = false;
        this.tableOption.expandRowKeys = [];
        if (this.tableData && this.tableData.length === 1) {
          this.tableOption.expandRowKeys.push(this.tableData[0].id);
        }
      });
    },
    getTermPassPage(page, params, orderId, type) {
      // this.tableLoading = true
      termPassPage(
        Object.assign({
          currPage: page.currentPage,
          pageSize: page.pageSize,
          orderId: orderId,
          type: type,
        }),
      ).then((response) => {
        this.termTableData = response.data.data.records;
        this.termPage.total = response.data.data.total;
        // this.tableLoading = false
      });
    },
    searchChange(form, done) {
      this.searchForm = form;
      this.page.currentPage = 1;
      this.getList(this.page, form);
      done();
      statistics(
        Object.assign(
          {
            event_name: '搜索',
            event_type: 'click',
          },
          this.staParams,
        ),
      );
    },
    presSubmitOrder(row, index) {
      let hasNoStart;
      let hasProcessing;
      row.flowList.forEach((ele) => {
        if (ele.status === 0 || ele.status === 1 || ele.status === 2) {
          hasNoStart = true;
        } else if (ele.status === 3) {
          hasProcessing = true;
        }
      });

      let msg = '确认提交订单？';
      if (hasNoStart) {
        msg =
          '您的项目还有未开始的任务，确认提交订单？提交后未开始的任务将变成取消状态';
      }

      this.$alert(msg, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        callback: (action) => {
          if (action === 'confirm') {
            submit(row.id).then((res) => {
              if (res.data.data > 0) {
                statistics(
                  Object.assign(
                    {
                      event_type: 'click',
                      event_name: '提交订单',
                      class_name: 'submit',
                      class_url: '/dotadmin/dotadmin/order/',
                      event_params: '{id: row.id}',
                    },
                    this.staParams,
                  ),
                );
                alertSuccessMsg();
              } else {
                alertErroMsg(errorSubmitOrderMsg(res.data.data));
              }
            });
          } else {
            this.$router.replace('/refresh');
          }
        },
      });
    },
    expandChanges(row, expendList) {
      if (!this.tableOption.expandRowKeys.includes(row.id)) {
        this.tableOption.expandRowKeys.push(row.id);
      } else {
        this.tableOption.expandRowKeys.splice(
          this.tableOption.expandRowKeys.findIndex((item) => item === row.id),
          1,
        );
      }
    },
    handleClick(orderFlow, flowId, status, orderId, flowLevel) {
      this.termOrderId = orderId;
      if (status === 0) {
        return;
      }
      if (orderFlow === 1) {
        this.$router.push({ path: '/dot/flow/detail-mt/' + flowId });
      } else if (orderFlow === 2) {
        this.$router.push({ path: '/dot/flow/detail-marking/' + flowId });
      } else if (orderFlow === 4) {
        if (flowLevel == 3) {
          this.$router.push({
            path: '/dot/flow/detail-pe/' + flowId,
          });
        }
        if (flowLevel == 4) {
          this.$router.push({
            path: '/dot/flow/detail-review/' + flowId,
          });
        }
        if (flowLevel == 5) {
          this.$router.push({
            path: '/dot/flow/detail-peReview/' + flowId,
          });
        }
      } else if (orderFlow === 6) {
        this.$router.push({
          path: '/dot/flow/detail-qc/' + flowId,
          query: { orderId: orderId, type: 'pm' },
        });
      } else if (orderFlow === 7) {
        this.termAuditDialogVisible = true;
        this.termType = 1;
        this.getTermPassPage(this.termPage, {}, orderId, 1);
      }
      statistics(
        Object.assign(
          {
            event_type: 'click',
            event_name: '查看/去配置',
          },
          this.staParams,
        ),
      );
    },
  },
  filters: {},
};
</script>
<style lang="scss" scoped>
.avue-view {
  background: #ffffff;
  padding: 20px;
}
span.hack {
  color: #c2c2c2;

  &.hack-h {
    color: #00bfff;
    font-weight: bold;
  }

  &.hack-config {
    color: #ff4000;
    font-weight: bold;
  }

  &.hack-hover {
    cursor: pointer;
  }
}

.el-table__body tr.hover-row.current-row > td,
.el-table__body tr.hover-row.el-table__row--striped.current-row > td,
.el-table__body tr.hover-row.el-table__row--striped > td,
.el-table__body tr.hover-row > td {
  background-color: unset;
}

:deep(.el-table__expanded-cell[class*='cell']) {
  padding: 10px 10px 10px 60px;
  tbody {
    tr.hover-row {
      background-color: unset;
      td {
        background-color: unset;
      }
    }
  }
}
</style>
